<template>
    <div class="netError" @click="refresh">
      <div>
        <img src="../assert/network-error.png" />
        <p>网络接不上了</p>
      </div>
  </div>
</template>

<script>
export default {
  name: 'net-error',
  methods: {
    refresh() {
      location.reload();
    }
  }
}
</script>


<style>
.netError {
  text-align: center;
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  font-size: 17px;
  color: #666666;
  background-color: #fff;
  z-index: 999999999;
  display: flex;
  align-items: center;
  justify-content: center;
}

netError>div {
  width: 40%;
}

.netError img {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/NetError.vue